import React from 'react';
import { Brain } from 'lucide-react';

export const EmptyAssistantsState: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh]">
            <Brain className="w-10 h-10 sm:w-12 sm:h-12 text-gray-200 mb-4" />
            <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-2">
                No Assistants Available
            </h2>
            <p className="text-gray-400 text-center max-w-md text-sm sm:text-base px-4">
                There are no AI assistants currently published. Please check back later.
            </p>
        </div>
    );
};